import "../sass/app.scss";

import CarouselHeroCaption from "./modules/CarouselHeroCaption";
import Animations from "./modules/Animations";
import CollapseMobileMenu from "./modules/CollapseMobileMenu";
import AjaxPagination from "./modules/AjaxPagination";
import Accordion from "./modules/Accordion";
import Carousel from './modules/Carousel';

// const threeSlideCarousel = new ThreeSlideCarousel();
const carouselHeroCaption = new CarouselHeroCaption();
const animations = new Animations();
const collapseMobileMenu = new CollapseMobileMenu();
const ajaxPagination = new AjaxPagination();
const accordion = new Accordion(); 
const carousel = new Carousel();